import {
  getOrganisationById,
  organisationByIdSelector,
  PRODUCT_ROUTES,
  PREDICT_PRODUCT_SLUG,
  PREDICT_PRODUCT_ID,
  consolidationByIdSelector,
  getConsolidationProductUrl,
  getOrganisationsSettingsUrl,
  getPredictSettingsOrganisationsPageUrl,
  getOrganisationDetailUrl
} from '@futrli/shared-services';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { StoreState } from '../../core/redux-utils/types';

export const ProductsManagementRedirect = (): JSX.Element => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisatioId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';
  const [organisationNotFound, setOrganisationNotFound] = useState<boolean>(false);
  const organisation = useSelector((store: StoreState) =>
    organisationByIdSelector(store.normalised, workspaceId, organisationId)
  );
  const consolidation = useSelector((store: StoreState) => consolidationByIdSelector(store.normalised, organisationId));
  const isConsolidation = !!consolidation;

  React.useEffect(() => {
    const loadOrganisation = async () => {
      if (!organisation && !isConsolidation) {
        try {
          await dispatch(getOrganisationById(workspaceId, organisationId));
        } catch {
          setOrganisationNotFound(true);
        }
      }
    };
    loadOrganisation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (organisationNotFound) {
    return <Navigate to={getOrganisationsSettingsUrl(workspaceId)} replace />;
  }

  if (consolidation && isConsolidation) {
    return (
      <Navigate
        replace
        to={{
          search: location.search,
          pathname: getConsolidationProductUrl(workspaceId, consolidation.id, PREDICT_PRODUCT_SLUG)
        }}
      />
    );
  }

  if (organisation) {
    const hasPredictEnabled = organisation.enabled_products.some(setup => setup.product_id === PREDICT_PRODUCT_ID);
    return (
      <Navigate
        replace
        to={{
          pathname: !hasPredictEnabled
            ? getPredictSettingsOrganisationsPageUrl(workspaceId)
            : getOrganisationDetailUrl(workspaceId, organisationId) + PRODUCT_ROUTES.PREDICT,
          search: location.search
        }}
      />
    );
  }

  return <></>;
};
